//Smooth Scrolling Using Navigation Menu
document.addEventListener('DOMContentLoaded', () => {
	$('a[href*="#"]:not(a[href="#bestellen"])').on('click', function (e) {
		$('html,body').animate(
			{
				scrollTop: $($(this).attr('href')).offset().top - 100,
			},
			500,
			'swing'
		);
		e.preventDefault();
	});

    if(window.location.hash) {
        $('html,body').animate(
            {
                scrollTop: $(window.location.hash).offset().top - 100,
            },
            500,
            'swing'
        );
    }

    // Specific scroll position for #bestellen in sticky cta bar
    $('a[href="#bestellen"]').on('click', function (e) {
        const scrollDestination = window.innerWidth > 991 ? '#bestellen' : '#mobile-bestellen';
        $('html,body').animate(
            {
                scrollTop: $(scrollDestination).offset().top - 20,
            },
            500,
            'swing'
        );
        e.preventDefault();
    });
});
